import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'

const Message = styled(BodyText)`
  padding-bottom: ${rem(16)};

  ${mediaQueryUp.tablet} {
    padding-bottom: 0;
  }
`

interface Props {
  isOpen: boolean
  title?: string
  primaryActionText?: string
  message?: string
  backBtnTitle?: string
  onGoBack?: () => void
  onReload: () => void
}

function SessionTimeoutModal(props: Props) {
  const intl = useIntl()

  const defaultTitle = intl.formatMessage({
    id: 'dhSY93qKyA',
    defaultMessage: 'Your session has expired',
    description: 'Default title for flight session timeout modal',
  })
  const defaultPrimaryActionText = intl.formatMessage({
    id: 'Sovpq92z35',
    defaultMessage: 'Refresh search',
    description: 'Default primary action button text for flight session timeout modal',
  })
  const defaultMessage = intl.formatMessage({
    id: 'oxlEayVl2d',
    defaultMessage: 'Flight prices fluctuate due to demand and availability. To make sure you are getting the most up to date prices, please refresh your search.',
    description: 'Default message explaining why flight session expired and prompting user to refresh',
  })

  const {
    isOpen,
    backBtnTitle,
    onGoBack,
    onReload,
    title = defaultTitle,
    primaryActionText = defaultPrimaryActionText,
    message = defaultMessage,
  } = props

  return (
    <Modal
      isOpen={isOpen}
      dismissible={false}
      title={title}
      primaryActionText={primaryActionText}
      secondaryActionText={backBtnTitle}
      onPrimaryActionClick={onReload}
      onSecondaryActionClick={onGoBack}
    >
      <Message variant="large">
        {message}
      </Message>
    </Modal>
  )
}

export default SessionTimeoutModal
